import React from 'react';
import { Modal, ModalHeader, ModalBody, Row, Col, Label, Button, ModalFooter } from 'reactstrap';
import Select from 'react-select';

export default ({ items, isOpen, onClose, onSave }) => {
    let versoesSeleconadas = [];

    const handleSave = () => {
        onSave(versoesSeleconadas);
    };

    const handleChange = (params) => {
        const { value } = params;
        const index = versoesSeleconadas.findIndex((x) => x.anoPer === value.anoPer && x.numPer === value.numPer);
        if (index >= 0) {
            versoesSeleconadas.splice(index, 1);
        }
        versoesSeleconadas.push(value);
    };

    return (
        <Modal isOpen={isOpen} toggle={onClose}>
            <ModalHeader className='modal-title' style={{ position: 'relative', height: 50 }}>
                <span style={{ position: 'absolute', left: '41%' }}>Versões do BI</span>
            </ModalHeader>
            <ModalBody>
                {items.map((x) => (
                    <Row style={{ alignItems: 'center', paddingBottom: '5px' }}>
                        <Col xs='12' sm='12' lg='12' xl='3'>
                            <Label htmlFor='idVersoes'>Pv: {x.numPer + '/' + x.anoPer}</Label>
                        </Col>
                        <Col xs='12' sm='12' lg='12' xl='6'>
                            <Select
                                id='idVersoes'
                                onChange={handleChange}
                                isClearable
                                //value={(y = x.versoes[0]) => ({ value: y._id, label: y.descricao })}
                                name='versoes'
                                options={x.versoes.map((y) => ({
                                    value: { anoPer: x.anoPer, numPer: x.numPer, id: y._id },
                                    label: y.descricao,
                                }))}
                                placeholder='Versoes'
                            />
                        </Col>
                    </Row>
                ))}
            </ModalBody>
            <ModalFooter>
                <Button type='submit' size='md' color='primary' onClick={handleSave}>
                    Salvar
                </Button>
            </ModalFooter>
        </Modal>
    );
};
